import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'not-supported-browser',
  templateUrl: './not-supported-browser.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotSupportedBrowserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
